export default "__VITE_ASSET__DdDhwmkJ__"